export const GENRE_FAMILIES = {
  "Hip-Hop / Rap": [
    "Hip-Hop", "Rap", "Trap", "Drill", "Boom Bap", "Cloud Rap", "Rap FR", "Rap US",
    "Grime", "Lo-fi Hip-Hop", "Rap Conscient", "Dirty South", "Mumble Rap",
    "Rap Emo", "Freestyle", "Horrorcore", "Jazz Rap", "Old School Rap",
  ],
  "R&B / Soul": [
    "R&B", "Soul", "Neo-Soul", "Funk", "Motown", "Gospel", "R&B Contemporain",
    "Quiet Storm", "New Jack Swing", "Disco", "P-Funk",
  ],
  "Pop": [
    "Pop", "Synth-Pop", "Indie Pop", "K-Pop", "J-Pop", "Electro-Pop", "Pop Rock",
    "Dream Pop", "Dance Pop", "Teen Pop", "Art Pop", "Baroque Pop",
    "Chamber Pop", "City Pop", "Pop Francaise", "Variete Francaise",
  ],
  "Electronique": [
    "Electro", "House", "Techno", "Trance", "Dubstep", "Drum & Bass", "Ambient",
    "EDM", "Lo-fi", "Garage", "Hardstyle", "Deep House", "Tech House",
    "Progressive House", "Minimal", "Downtempo", "Chillout", "Breakbeat",
    "Jungle", "Industrial", "Synthwave", "Future Bass", "UK Garage", "Jersey Club",
  ],
  "Rock / Metal": [
    "Rock", "Metal", "Punk", "Grunge", "Indie Rock", "Hard Rock", "Post-Rock",
    "Prog Rock", "Emo", "Shoegaze", "Rock Alternatif", "Stoner Rock",
    "Psychedelic Rock", "Garage Rock", "Noise Rock", "Math Rock",
    "Post-Punk", "New Wave", "Metalcore", "Death Metal", "Black Metal",
    "Power Metal", "Nu Metal", "Doom Metal", "Thrash Metal", "Pop Punk",
    "Hardcore", "Screamo", "Brit Rock",
  ],
  "Afro / Caribeen": [
    "Afrobeats", "Afro-Pop", "Amapiano", "Coupe-Decale", "Ndombolo", "Dancehall",
    "Reggae", "Soca", "Zouk", "Kompa", "Afro-House", "Afro-Swing",
    "Highlife", "Afro-Fusion", "Gqom", "Kwaito", "Makossa", "Mbalax",
    "Kuduro", "Calypso", "Bouyon", "Gwoka",
  ],
  "Latin": [
    "Reggaeton", "Latin Pop", "Bachata", "Salsa", "Cumbia", "Dembow",
    "Bossa Nova", "Samba", "Merengue", "Vallenato", "Tango", "Ranchera",
    "Corridos", "Latin Trap", "Latin Jazz", "MPB", "Forro",
  ],
  "Jazz / Blues": [
    "Jazz", "Blues", "Jazz Fusion", "Smooth Jazz", "Bebop", "Swing",
    "Jazz Manouche", "Free Jazz", "Cool Jazz", "Hard Bop", "Soul Jazz",
    "Acid Jazz", "Jazz Vocal", "Blues Rock", "Chicago Blues", "Delta Blues",
    "Electric Blues",
  ],
  "Chanson / Variete": [
    "Chanson Francaise", "Variete", "Chanson a Texte", "Nouvelle Chanson",
    "Slam", "Spoken Word", "Cabaret", "Chanson Realiste",
  ],
  "Classique / Monde": [
    "Classique", "Orchestral", "Opera", "Musique de Film", "Musique Medievale",
    "Baroque", "Romantique", "Contemporain",
    "World Music", "Folk", "Country", "Rai", "Flamenco", "Celtic",
    "Musique Arabe", "Musique Indienne", "Musique Asiatique", "Musique Africaine",
    "Ethno", "Gnawa", "Fado", "Klezmer",
  ],
  "Autres": [
    "Acoustic", "Instrumental", "Experimental", "Phonk", "Chillwave",
    "Vaporwave", "Musique Chill", "ASMR", "Meditation", "Musique de Jeu Video",
    "Mashup", "Musique pour Enfants", "Podcast Musical", "Beatbox",
    "A Cappella", "Singer-Songwriter",
  ],
};

export const ALL_GENRES = Object.values(GENRE_FAMILIES).flat();

export const GENRE_FAMILY_NAMES = Object.keys(GENRE_FAMILIES);
